"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _ramda = require("ramda");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _book = require("../../../../../routes/book");
var _Collapsed = require("../../../../../ui/Collapsed");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _selectors2 = require("../../../../../collections/store/selectors");
var _actions = require("../../../../../../bus/ui/actions");
var _constants = require("./store/constants");
var _store = require("./store");
var _SimilarHotel = require("./components/SimilarHotel");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SimilarHotels = function SimilarHotels(_ref) {
  var queryID = _ref.queryID;
  var hotels = (0, _reactRedux.useSelector)(_store.getSimilarHotels);
  var searchHotelsUI = (0, _reactRedux.useSelector)(_store.searchSimilarHotelsUI);
  var shouldRenderAddToCollectionButton = (0, _reactRedux.useSelector)(_selectors2.isEnabledCollectionsFeature);
  var selectedHotels = (0, _reactRedux.useSelector)(_store.getSelectedHotels);
  var activeCurrencyCode = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getQueryParam)(state, {
      queryID: queryID,
      paramName: _fn.QUERY_PARAMS.CURRENCY
    });
  });
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var isHotelPage = (0, _reactRouter.useRouteMatch)(_book.book.hotel);
  var dispatch = (0, _reactRedux.useDispatch)();
  var onSearch = (0, _react.useCallback)(function () {
    dispatch((0, _store.onSearchSimilarHotels)(queryID));
  }, [dispatch, queryID]);
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _actions.unRegister)(_constants.SEARCH_SIMILAR_HOTELS_UI));
      dispatch((0, _store.resetStore)());
    };
  }, [dispatch]);
  return !(0, _ramda.isEmpty)(hotels) && /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    initialOpen: true,
    title: t('SIMILAR_HOTELS_TITLE'),
    loading: searchHotelsUI.loading,
    className: _styles.default.collapsed,
    contentClassName: _styles.default.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.hotels
  }, (0, _ramda.map)(function (_ref2) {
    var hotelID = _ref2.hotelID,
      percentageSimilarity = _ref2.percentageSimilarity;
    return /*#__PURE__*/_react.default.createElement(_SimilarHotel.SimilarHotel, {
      currencyCode: activeCurrencyCode,
      disabledSelection: isHotelPage,
      hotelID: Number(hotelID),
      percentageSimilarity: percentageSimilarity,
      key: hotelID,
      selected: Boolean(selectedHotels[hotelID]),
      isEnabledCollectionsFeature: shouldRenderAddToCollectionButton
    });
  }, hotels)), !isHotelPage && /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    onClick: onSearch
  }, t('SIMILAR_HOTELS_SEARCH_BUTTON')));
};
SimilarHotels.propTypes = {
  queryID: _propTypes.default.string.isRequired
};
var _default = exports.default = SimilarHotels;